import { PROFILES } from '../constants';
import { useSession } from './use-session.hook';
import { useMemo } from 'react';

interface useHasAccessProps {
  view?: string[];
  onlyRoot?: boolean;
}

const useHasAccess = ({ view = [], onlyRoot = false }: useHasAccessProps) => {
  const { session } = useSession();

  const isAllowed = useMemo(() => {
    if (!session?.profile) return null;

    if (onlyRoot) {
      return session.profile === PROFILES.ROOT;
    } else {
      return view.includes(session.profile);
    }
  }, [session?.profile, view.join(','), onlyRoot]);

  return { isAllowed };
};

export default useHasAccess;
